// extracted by mini-css-extract-plugin
export default {"policy-holders-form":"styles_policy-holders-form__BMQEm","loading":"styles_loading__fJp4z"};